import { useEffect } from "react"
import { preLoaderAnim } from "../animations"

const PreLoader = () => {

  useEffect(()=> {
    preLoaderAnim()
  })

  return (
    <div className="preloader">
      <div className="texts-container">
        <span>Dévéloppeur,</span>
        <span>Formateur,</span>
        <span>Blogeur.</span>
      </div>
    </div>
  )
}

export default PreLoader;